var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
/**
 * Example of a Native Date adapter
 */
var NgbDateStringAdapter = /** @class */ (function (_super) {
    __extends(NgbDateStringAdapter, _super);
    function NgbDateStringAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbDateStringAdapter.prototype.fromModel = function (dateString) {
        if (!dateString) {
            return null;
        }
        var date = new Date(dateString);
        return (date && date.getFullYear) ? { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } : null;
    };
    NgbDateStringAdapter.prototype.toModel = function (date) {
        if (!date) {
            return null;
        }
        var month = date.month < 10 ? '0' + date.month : date.month;
        var day = date.day < 10 ? '0' + date.day : date.day;
        return date.year + "-" + month + "-" + day;
    };
    return NgbDateStringAdapter;
}(NgbDateAdapter));
export { NgbDateStringAdapter };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/services/ngb-date-string-adapter.service.ts.pre-build-optimizer.js